export const en = {
  interviewInstructions: {
    title: "Getting Ready for Your Video Screening",
    description:
      "Complete these 4 simple steps to ensure a smooth video screening experience.",
    steps: [
      {
        title: "Configure your devices",
        description:
          "Allow browser permissions and ensure your camera and microphone work properly.",
      },
      {
        title: "Begin your interview",
        description: "Click 'Start Interview.'",
        tooltip:
          "Recording will start automatically when you click the button. No need to start/stop recording manually.",
      },
      {
        title: "Answer each question",
        description:
          "Each question will appear on screen. Speak your answer clearly. No need to type your responses.",
      },
      {
        title: "Move through all questions",
        description:
          "Click 'Next Question' to proceed. You will answer {count} questions.",
      },
    ],
    buttonText: "Got it",
  },
  previewScreen: {
    title: "You're about to start",
    description:
      "The next step is to complete a quick video interview with our AI assistant. Please check these recommendations before your interview: take time to answer every question, and remember that the interview could last around 20 minutes in total.",
    microphoneTest: {
      title: "Microphone Test",
      description:
        'Click "Start Recording" and speak clearly for a few seconds. A visual indicator will show your volume level. Recording stops automatically after 10 seconds.',
      startRecording: "Start Recording",
      recording: "Recording...",
      playRecording: "Play Recording",
      reset: "Reset",
      recordingTime: "Recording Time",
    },
    aboutProcess: {
      title: "About the process",
      steps: [
        "Click 'Start Interview.' Recording begins automatically, with no option to start, pause, or stop manually. All responses are video-recorded, covering technical and behavioral questions for a complete skill assessment.",
        'Respond to each question on video. Use "Next Question" to move forward. Complete all {count} questions to finish.',
      ],
    },
    checkbox: {
      label: "I meet the requirements mentioned to start this interview.",
    },
    multipleCamera: {
      title: "Multiple Cameras Detected",
      description:
        "Multiple cameras have been detected. Please ensure that the correct camera is selected and turned on, as it is important for accurately assessing the screening.",
      close: "Close",
      configure: "Configure",
    },
    previewName: {
      startInterview: "Start interview now",
      nextQuestion: "Next question",
      scheduleInterview: "Schedule Interview",
    },
  },
  leaveRoom: {
    finishProcess: "Finish process",
    nextQuestion: "Next question",
    skipQuestion: "Skip question",
    confirmSkip: "Are you sure you want to skip this question?",
    confirmNext: "Are you sure you want to move on to the next question?",
    finalWarning: "This action is final — you won't be able to go back.",
    cancel: "Cancel",
    confirm: "Confirm",
    noAudioModal: {
      title: "No Audio Detected",
      description:
        "No audio has been detected in the last 25 seconds. Please make sure your microphone is working properly.",
      close: "Close",
      configure: "Configure",
    },
  },
  polls: {
    questionForm: {
      questionNumber: "Question",
      of: "of",
      questionType: "Question Type",
      placeholder: "Ask a question",
      options: "Options",
      optionsHint: "(Use checkboxes to indicate correct answers)",
      addOption: "Add Option",
      notRequired: "Not required to answer",
      save: "Save",
      deleteQuestion: "Delete question?",
      deleteConfirm:
        "Are you sure you want to delete this question? This action cannot be undone.",
      cancel: "Cancel",
      delete: "Delete",
    },
    savedQuestion: {
      edit: "Edit",
    },
  },
  conference: {
    initializingRecording: "Initializing recording",
    recording: "Recording",
    question: "Question",
    of: "of",
    answerInLanguage: "Please answer this question in",
    copyNotAllowed:
      "Copying the questions is not allowed, your attempt has been logged. 🚨",
    languages: {
      English: "English",
      Spanish: "Spanish",
      Español: "Spanish",
    },
  },
};
